import type { TProcedureStatus } from '../../../../react-query/useVisitSummaries';
import { ProcedureStatus } from '../../../../react-query/useVisitSummaries';

export const VisitSummariesStatusPriority: Record<
  TProcedureStatus | 'normal',
  number
> = {
  [ProcedureStatus.scheduled_today]: 10,
  [ProcedureStatus.scheduled_future]: 20,
  [ProcedureStatus.unscheduled]: 30,
  [ProcedureStatus.completed]: 40,
  [ProcedureStatus.recommended]: 50,
  normal: 60,
};

export const getHexFromProcedureStatus = (
  status: TProcedureStatus,
  isDarkMode: boolean,
) => {
  return isDarkMode
    ? ProcedureStatusToHexDarkMode[status]
    : ProcedureStatusToHex[status];
};

export const ProcedureStatusToHex: Partial<Record<TProcedureStatus, string>> = {
  completed: '#62BFF5',
  recommended: '#7E22CE',
  scheduled_future: '#94A3B8',
  scheduled_today: '#94A3B8',
  unscheduled: '#EF4444',
};

export const ProcedureStatusToHexDarkMode: Partial<
  Record<TProcedureStatus, string>
> = {
  completed: '#3183FF',
  recommended: '#6D28D9',
  scheduled_future: '#475569',
  scheduled_today: '#475569',
  unscheduled: '#EF4444',
};

// TODO: Find a more reliable way to define this list
export const permanentOnlyTeeth = [
  '1',
  '2',
  '3',
  '14',
  '15',
  '16',
  '17',
  '18',
  '19',
  '30',
  '31',
  '32',
] as const;
